<div id="wrapper" class="middle-wrapper">
    <app-layout-header [environment]="environment"></app-layout-header>
    <div id="middle-wrapper" [hidden]="isLoadingPanel" >
        <router-outlet></router-outlet>
    </div>
    <app-layout-footer></app-layout-footer>
  </div>
  <div class="loading-spiner-holder" [hidden]="!isLoadingPanel" loading>
    <div class="loading-spiner"><img src="assets/images/loader.gif" alt="Loading..." /></div>
  </div>
  



